import api from './api';

export const registrationService = {
  // Patient Search & Demographics
  searchPatients: async (query, limit = 20) => {
    const response = await api.get('/patients/search', { params: { query, limit } });
    return response.data;
  },

  getPatient: async (uhid) => {
    const response = await api.get(`/patients/${uhid}`);
    return response.data;
  },

  checkDuplicate: async (mobile, name, excludeUhid = null) => {
    const response = await api.get('/patients/check-duplicate', {
      params: { mobile, name, excludeUhid: excludeUhid || undefined },
    });
    return response.data;
  },

  // Registration & Work Orders
  createRegistration: async (data) => {
    const config = {};
    if (data && data.idempotencyKey) {
      config.headers = { 'X-Idempotency-Key': data.idempotencyKey };
    }
    const response = await api.post('/registrations', data, config);
    return response.data;
  },

  getRegistration: async (labno) => {
    const response = await api.get(`/registrations/${labno}`);
    return response.data;
  },

  getReceipt: async (labno) => {
    const response = await api.get(`/registrations/${labno}/receipt`);
    return response.data;
  },

  getRecentRegistrations: async (params = {}) => {
    const response = await api.get('/registrations', { params });
    return response.data;
  },
};

export default registrationService;
